<template>
  <div>
    <div class="relative my-8">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-300"></div>
      </div>
      <div class="relative flex justify-center">
        <span class="bg-white px-3 text-lg font-medium"> Documents follow-up </span>
      </div>
    </div>

    <div>
      <p class="member-form-sublabel">
        If there are any documents you still need from the member, select them below. 
        Cara will automatically send a message with the list.
      </p>
    </div>
  </div>
</template>

